/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 30/07/13
 * Time: 10:58
 * To change this template use File | Settings | File Templates.
 */


angular.module('FlexyBeautyApp.services').
    factory('PosOp_Resource',["$resource","$location", function ($resource,$location)
    {
        var baseUrl = $location.protocol()  + "://" + $location.host() + ($location.port() && ":" + $location.port())  + "/";
        var  resourceBooking = $resource( baseUrl +'rest/posOps/:id',{}, {
            query: { method: 'GET', isArray: true },
            get:   { method: 'GET'},
            export: { method: 'POST', url:baseUrl+'rest/pos/export'}

        });
        return resourceBooking;
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('PosOp',["PosOp_Resource","PosOpData","HumanResourceData", function (PosOp_Resource,PosOpData,HumanResourceData)
    {
        var  PosOp = function (resource,day,isPreviousVersion)
        {
            this.id = null;
            this.isDeleted = false;
            this.type = null;
            this.desc = null;
            this.poNumber = null;
            this.status = null;
            this.amount = null;
            this.humanResource =null;
            this.day = day;
            this.timeCreated = null;
            this.version = null;
            this.loadObject(resource);
            if (isPreviousVersion==undefined || !isPreviousVersion)//A previous version is not added to DATA
                PosOpData.add(this);
        };
        PosOp.prototype.loadObject = function(object)
        {
            if (object!==undefined && object!=null)
            {
                if (!this.id)
                    this.id = object.id;
                this.isDeleted = object.isDeleted;
                this.type = object.type;
                this.desc = object.desc;
                this.poNumber = object.poNumber;
                this.status = object.status;
                this.amount = object.amount;
                if (object.timeCreated)
                    this.timeCreated = new Date(object.timeCreated);
                if (object.humanResourceId)
                    this.humanResource = HumanResourceData.getById(object.humanResourceId);
                if (object.version)
                    this.version = object.version;
            }
        };
        PosOp.prototype.getObjectResource = function()
        {
            var rsPosOp = new PosOp_Resource();
            rsPosOp.id = this.id;
            rsPosOp.isDeleted = this.isDeleted;
            rsPosOp.type = this.type;
            rsPosOp.desc = this.desc;
            rsPosOp.status = this.status;
            rsPosOp.amount = this.amount;
            if (this.humanResource)
                rsPosOp.humanResourceId = this.humanResource.id;
            if (this.day)
                rsPosOp.dayId = this.day.id;
            return rsPosOp;
        };

        PosOp.prototype.getId = function()
        {
            return this.id;
        };

        PosOp.prototype.setId = function(id)
        {
            this.id = id;
        };

        return PosOp;
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('PosOpSrv',["$log","PosOp_Resource","UserActionData","PosOp","PosOpData","ServerSrv","DayData",
        function ($log,PosOp_Resource,UserActionData,PosOp,PosOpData,ServerSrv,DayData)
        {
        var  posOpSrv = {};

        posOpSrv.query = function(successFunction,errorFunction)
        {
            PosOp_Resource.query(
                {}, //params
                function (data) {   //success
                    PosOpData.clear() ;
                    for (var i=0;i< data.length;i++)
                        new PosOp(data[i]);//Auto Add to PosOpData
                    if (successFunction!== undefined)
                        successFunction(PosOpData.indexPosOps);

                },
                function (data) {   //failure
                    $log.error("PosOp_Resource.query error");
                    $log.error(data);
                    if (errorFunction!== undefined)
                        errorFunction(data);
                });
        };

        posOpSrv.export = function(successFunction,errorFunction)
        {
            PosOp_Resource.export(
                {}, //params
                function () {   //success
                    if (successFunction!== undefined)
                        successFunction(PosOpData.indexPosOps);
                    },
                function (data) {   //failure
                    if (errorFunction!== undefined)
                        errorFunction(data);
                });
        };
        posOpSrv.save = function(posOp,successFunction,errorFunction)
        {
            ServerSrv.startSavingProcess(posOpSrv.saveSync, posOp, successFunction, errorFunction);
        };
        posOpSrv.saveSync = function(posOp,successFunction,errorFunction)
        {
            var PosOpRes = posOp.getObjectResource();
            PosOpRes.$save({}, //no params
                function (data) {
                    try{
                        posOp.setId(data.id);
                        if (!posOp.version || (data.version && data.version > posOp.version))
                            posOp.version = data.version;
                        if (!posOp.poNumber)
                            posOp.poNumber = data.poNumber;
                        if (successFunction !=undefined)
                            successFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try {
                        if (errorFunction != undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );
        };
        posOpSrv.remove = function(posOp,successFunction,errorFunction)
        {
            PosOpData.remove(posOp);
            ServerSrv.startSavingProcess(posOpSrv.removeSync, posOp, successFunction, errorFunction);
        };
        posOpSrv.removeSync =  function(posOp,successFunction,errorFunction)
        {
            var posOpSrv = new PosOp_Resource();
            posOpSrv.$remove({id:posOp.getId()}, //params : id
                function (data) {
                    try{
                        if (successFunction !=undefined)
                            successFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try {
                        if (errorFunction != undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );
        };
        posOpSrv.restore = function(posOp,successFunction,errorFunction)
        {
            PosOpData.restore(posOp);
            ServerSrv.startSavingProcess(posOpSrv.restoreSync, posOp, successFunction, errorFunction);
        };
        posOpSrv.restoreSync = function(posOp,successFunction,errorFunction)
        {
            var PosOpRes = posOp.getObjectResource();
            PosOpRes.$save({}, //no params
                function (data) {
                    try{
                        posOp.setId(data.id);
                        if (successFunction !=undefined)
                            successFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try {
                        if (errorFunction != undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );
        };
        posOpSrv.get =  function(id,successFunction,errorFunction)
        {
            PosOp_Resource.get(
                {id:id}, //params
                function (posOpResource) {
                    if (successFunction!=undefined)
                        successFunction(new PosOp(posOpResource));
                },
                function (data) {
                    if (errorFunction !=undefined)
                        errorFunction(data);
                });
        };

        posOpSrv.updateLocally =  function(id,resource)
        {
            var day =  DayData.getById(resource.dayId);
            var posOp =  PosOpData.getById(id);
            if (day && posOp)
            {
                if (posOp.day!==day) {
                    posOp.day.removePosOp(posOp);
                    day.addPosOp(posOp);
                }
                posOp.loadObject(resource);
            }
            return posOp;
        };
        posOpSrv.removeLocally =  function(id,resource)
        {
            var posOp =  PosOpData.getById(id)
            if (posOp!=null)
            {
                if (posOp.day)
                    posOp.day.removePosOp(posOp);
            }
            return posOp;
        };
        posOpSrv.addLocally =  function(id,resource)
        {
            var posOp =  PosOpData.getById(id)
            var day = DayData.getById(resource.dayId);
            if (posOp!=null) //check if resource already exist inside index (current action could be a 'cancel')
                posOp.loadObject(resource);
            else
            {
                posOp = new PosOp(resource,day);
                posOp.id = id;
            }
            if (day)
                day.addPosOp(posOp);

            return posOp;

        };

        return posOpSrv;
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('PosOpData',["$filter", function ($filter)
    {
        var  posOpDataSrv =
        {
            indexPosOps : [],
            activePosOps : [],
            deletedPosOps : []//deleted items
        };
        posOpDataSrv.getById =  function(posOpId)
        {
            for (var i=0;i<this.indexPosOps.length;i++)
                if (this.indexPosOps[i].getId()==posOpId)
                    return this.indexPosOps[i];
            return null;
        }
        posOpDataSrv.getByIndex =  function(index)
        {
            if (index>=0 && index <this.indexPosOps.length)
                return this.indexPosOps[index];
            return null;
        }
        posOpDataSrv.getIndexOf =  function(posOp)
        {
            if (posOp)
                return this.indexPosOps.indexOf(posOp);
            return -1;
        }

        posOpDataSrv.add =  function(posOp)
        {
            var posOpArray = this.activePosOps;
            if (posOp.isDeleted)
                posOpArray =  this.deletedPosOps;
            var index =  this.indexPosOps.indexOf(posOp);
            if (index!=-1)
            {
                var realIndex = posOpArray.indexOf(posOp);
                if (realIndex==-1)
                    posOpArray.push(posOp);
            }
            else
            {
                index = this.indexPosOps.length
                this.indexPosOps.push(posOp);
                posOpArray.push(posOp);
            }
            return index;
        }        
        posOpDataSrv.remove =  function(posOp)
        {
            var index =  this.activePosOps.indexOf(posOp);
            if (index!=-1)
            {
                this.activePosOps.splice(index, 1);
                this.deletedPosOps.push(posOp) ;
                posOp.isDeleted=true;
            }
        }
        posOpDataSrv.restore =  function(posOp)
        {
            var index =  this.deletedPosOps.indexOf(posOp);
            if (index!=-1)
            {
                this.deletedPosOps.splice(index, 1);
                this.activePosOps.push(posOp);
                posOp.isDeleted=false;
            }
        }
        posOpDataSrv.clear =  function()
        {
            this.indexPosOps = [];
            this.activePosOps = [];
            this.deletedPosOps = [];
        }
        posOpDataSrv.sort =  function()
        {
            this.activePosOps = $filter('orderBy')(this.activePosOps,'type', false);
            this.deletedPosOps = $filter('orderBy')(this.deletedPosOps,'type', false);
        }

        posOpDataSrv.getActiveList =  function()
        {
            return this.activePosOps;
        }
        posOpDataSrv.getDeletedList =  function()
        {
            return this.deletedPosOps;
        }
        return   posOpDataSrv;
    }
    ]);


// WEBPACK FOOTER //
// ./js/services/models/PosOp.js